import { FileIconPlaceholder } from '../../FileIcon'
import { BirdviewRowRelativeTime } from '../BirdviewRowRelativeTime'
import { DashboardListRow } from '../DashboardListRow'

function BirdviewDocumentRow({ item, onOpen }) {
  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      Before={FileIconPlaceholder}
      Meta={BirdviewRowRelativeTime}
      beforeProps={{ type: item.fileType }}
      metaProps={{ date: item.updated }}
      subtitle={item.address}
      title={item.title}
      onAction={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewDocumentRow
